import style from "./style.module.css";
import Header from '@components/Header';
import Container from '@components/Container';
import Footer from '@components/Footer';

const BlogAutostartCommand = () => {
    return (
        <div>
            <Header type="mini" />
            <section className={style.contacts_section}>
                <Container>
                    <div className={style.content_article}>
                        <h2>Настройка Autoexec в CS2 — Руководство по Автоматизации</h2>

                        <p>Файл autoexec.cfg открывает множество путей для индивидуальной настройки Counter-Strike 2. В этом руководстве вы узнаете, как правильно его создать, какие команды стоит использовать и как применить файл для улучшения комфорта и эффективности игры.</p>

                        <h3>Зачем нужен файл autoexec</h3>
                        <p>Файл autoexec.cfg — это конфигурация, позволяющая сохранять пользовательские настройки и автоматически применять их при каждом запуске игры. Это особенно удобно, если вы используете нестандартные бинды, настройки прицела, радар или модель просмотра рук.</p>

                        <h3>Как создать autoexec.cfg</h3>
                        <ol>
                            <li>Создайте новый текстовый документ в любом редакторе (например, Notepad).</li>
                            <li>Вставьте нужные команды.</li>
                            <li>Сохраните файл с расширением <code>.cfg</code> под именем <code>autoexec.cfg</code>.</li>
                            <li>Переместите его в папку: <code>Steam\steamapps\common\Counter-Strike Global Offensive\game\csgo\cfg</code>.</li>
                        </ol>

                        <h3>Активация файла в CS2</h3>
                        <p>Чтобы ваш autoexec выполнялся автоматически, добавьте в параметры запуска игры:</p>
                        <p>+exec autoexec.cfg</p>
                        <p>Для этого кликните ПКМ по игре в Steam → Свойства → Установить параметры запуска.</p>

                        <h3>Примеры полезных команд</h3>

                        <h3>Бинды на гранаты</h3>
                        <ol>
                            <li><code>bind capslock "slot7"</code> — флешка</li>
                            <li><code>bind c "slot8"</code> — дымовая граната</li>
                            <li><code>bind x "slot6"</code> — HE-граната</li>
                            <li><code>bind alt "slot10"</code> — молотов</li>
                        </ol>

                        <h3>Настройка прицела</h3>
                        <ol>
                            <li><code>cl_crosshairstyle</code> — стиль прицела</li>
                            <li><code>cl_crosshairdot</code> — точка в центре</li>
                            <li><code>cl_crosshairsize</code> — размер прицела</li>
                            <li><code>cl_crosshairthickness</code> — толщина</li>
                            <li><code>cl_crosshaircolor</code> — цвет</li>
                            <li><code>cl_crosshairgap</code> — зазор между линиями</li>
                            <li><code>cl_crosshairusealpha</code> — прозрачность</li>
                        </ol>

                        <h3>Настройка модели рук</h3>
                        <ol>
                            <li><code>viewmodel_fov</code> — поле зрения (макс. 68)</li>
                            <li><code>viewmodel_offset_x</code> — смещение по горизонтали</li>
                            <li><code>viewmodel_offset_y</code> — смещение вперёд/назад</li>
                            <li><code>viewmodel_offset_z</code> — смещение по вертикали</li>
                        </ol>

                        <h3>Настройки радара</h3>
                        <ol>
                            <li><code>cl_radar_scale</code> — масштаб карты</li>
                            <li><code>cl_hud_radar_scale</code> — размер радара на экране</li>
                            <li><code>cl_radar_icon_scale_min</code> — размер иконок</li>
                            <li><code>cl_radar_always_centered</code> — центрирование</li>
                            <li><code>cl_radar_rotate</code> — поворот радара</li>
                        </ol>

                        <h3>FAQ</h3>
                        <p><strong>Как вручную запустить autoexec?</strong><br />Откройте консоль в CS2 и введите <code>exec autoexec</code>.</p>

                        <p><strong>Что делает autoexec?</strong><br />Это файл с командами, который загружается каждый раз при запуске игры и автоматически применяет ваши настройки.</p>

                        <p><strong>Используют ли профессионалы autoexec?</strong><br />Да, большинство про-игроков используют autoexec для сохранения нужных настроек и повышения стабильности игрового процесса.</p>

                        <p>Используйте autoexec для максимального контроля над вашей игрой — от интерфейса до производительности.</p>
                    </div>
                </Container>
            </section>
            <Footer />
        </div>
    );
};

export default BlogAutostartCommand;
